'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;
// import { localStore } from '../../../utils/localStorage';

// import exuWhite from 'assets/img/membership/exuWhite.png';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactRedux = require('react-redux');

var _setup = require('redux/modules/setup');

var setupActions = _interopRequireWildcard(_setup);

var _voucher = require('redux/modules/voucher');

var voucherActions = _interopRequireWildcard(_voucher);

var _booking = require('redux/modules/booking');

var bookingActions = _interopRequireWildcard(_booking);

var _reactBootstrap = require('react-bootstrap');

var _image_voucher = require('../../AccountManagement/image_voucher.jpg');

var _image_voucher2 = _interopRequireDefault(_image_voucher);

var _numeral = require('numeral');

var _numeral2 = _interopRequireDefault(_numeral);

var _lib = require('helpers/lib');

var _reactRouter = require('react-router');

var _lodash = require('lodash');

var _store = require('assets/img/membership/store.png');

var _store2 = _interopRequireDefault(_store);

var _mapMarker = require('assets/img/membership/mapMarker.png');

var _mapMarker2 = _interopRequireDefault(_mapMarker);

var _saleBadge = require('assets/img/membership/saleBadge.png');

var _saleBadge2 = _interopRequireDefault(_saleBadge);

var _calendar = require('assets/img/membership/calendar.png');

var _calendar2 = _interopRequireDefault(_calendar);

var _gift = require('assets/img/membership/gift.png');

var _gift2 = _interopRequireDefault(_gift);

var _reactQrSvg = require('react-qr-svg');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MESSAGE = {
  SUCCESS: {
    status: 'success',
    title: 'Tham gia thành công',
    content: 'Chúc bạn tận hưởng dịch vụ! Nhớ trình màn hình ưu đãi này cho nhân viên tại salon nhé!',
    subContent: 'Hãy gọi ngay cho shop để biết thông tin chi tiết!',
    call: true
  },
  WARNING: {
    status: 'warning',
    title: 'Đã tham gia',
    content: 'Bạn đã tham gia chương trình này rồi!',
    subContent: 'Hãy gọi ngay cho shop để biết thông tin chi tiết!',
    call: true
  },
  ERROR: {
    status: 'error',
    title: 'Lỗi',
    content: 'Tham gia không thành công, vui lòng báo với chúng tôi. Cảm ơn bạn!'
  },
  REQUIRED_LOGIN: {
    status: 'warning',
    title: 'Đăng nhập',
    content: 'Bạn cần đăng nhập để tham gia chương trình này!',
    require: 'login'
  },
  UPDATE_PHONE: {
    status: 'warning',
    title: 'Cập nhật thông tin',
    content: 'Bạn cần cập nhật thông tin số điện thoại để sử dụng khuyến mãi.',
    require: 'update_phone'
  }
};
var VoucherDetail = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    detail: state.voucher.detail,
    reward_detail: state.voucher.reward_detail,
    // codeToSubmit: state.voucher.codeToSubmit,
    code: state.voucher.code,
    toggleJoin: state.voucher.toggleJoin,
    joinCampaignData: state.voucher.joinCampaignData,
    joinCampaignError: state.voucher.joinCampaignError,
    // promotionsEnterprise: state.voucher.promotionsEnterprise,
    user: state.auth.user
  };
}, (0, _extends3.default)({}, voucherActions, {
  resetBooking: bookingActions.resetBooking,
  setDefaultBooking: bookingActions.setDefaultBooking,
  // loadCampaignByCode: bookingActions.loadCampaignByCode,
  setPathName: _setup.setPathName,
  showDownloadAppPopup: setupActions.showDownloadAppPopup
})), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(VoucherDetail, _Component);

  function VoucherDetail() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, VoucherDetail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = VoucherDetail.__proto__ || (0, _getPrototypeOf2.default)(VoucherDetail)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isUsed: false,
      showModalJoin: false,
      warningJoin: {
        title: 'Thông Báo',
        code: 'warning',
        content: 'Bạn có chắc chắn sử dụng ưu đãi này không?',
        note: ''
      },
      infoMessage: {
        title: '',
        content: ''
      },
      showModalInfo: false
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(VoucherDetail, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var params = this.props.params;

      this.props.getRewardDetails(params.handle);
      // this.props.getVoucherById(params.handle);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var infoMessage = {};
      if (!(0, _lodash.isEqual)(this.props.joinCampaignData, nextProps.joinCampaignData) && nextProps.joinCampaignData) {
        var _nextProps$joinCampai = nextProps.joinCampaignData,
            isUsed = _nextProps$joinCampai.isUsed,
            message = _nextProps$joinCampai.message;

        if (isUsed) {
          // Đã sử dụng trước đó rồi.
          infoMessage = (0, _extends3.default)({}, MESSAGE.WARNING, { content: message });
        } else {
          // Chưa sử dụng, mới vừa request sử dụng và thành công.
          infoMessage = (0, _extends3.default)({}, MESSAGE.SUCCESS, { content: message });
        }
        this.setState({ infoMessage: infoMessage, showModalInfo: true });
      }
      if (!(0, _lodash.isEqual)(this.props.joinCampaignError, nextProps.joinCampaignError) && nextProps.joinCampaignError) {
        var _message = nextProps.joinCampaignError.message;

        infoMessage = (0, _extends3.default)({}, MESSAGE.ERROR, { content: _message });
        this.setState({ infoMessage: infoMessage, showModalInfo: true });
      }
    }
  }, {
    key: 'joinCampaign',
    value: function joinCampaign() {
      var _props = this.props,
          joinCampaign = _props.joinCampaign,
          campaign = _props.detail.campaign;

      var data = {
        code: '',
        packId: '',
        typeVoucher: campaign.typeVoucher,
        token: this.props.user.token
      };
      data.code = campaign.code;
      data.packId = campaign.onePackage;
      joinCampaign(data);
      this.closeModalJoin.call(this);
    }
  }, {
    key: 'handleJoin',
    value: function handleJoin() {
      var campaign = this.props.detail.campaign;

      if (this.props.user) {
        if (!this.props.user.phone) {
          var infoMessage = MESSAGE.UPDATE_PHONE;
          this.setState({ infoMessage: infoMessage, showModalInfo: true });
        } else {
          this.openModalJoin.call(this);
        }
        _reactGa2.default.event({
          category: 'Promotion',
          action: 'Clicked Join button',
          label: '' + campaign.code
        });
      } else {
        this.setState({
          infoMessage: MESSAGE.REQUIRED_LOGIN,
          showModalInfo: true
        });
        _reactGa2.default.event({
          category: 'Promotion',
          action: 'Clicked Join button (not logged in)',
          label: '' + campaign.code
        });
      }
    }
  }, {
    key: 'handleLogin',
    value: function handleLogin() {
      var history = this.props.history;

      this.props.setPathName('uu-dai/' + this.props.detail.handle);
      history.push('/dang-nhap');
    }
  }, {
    key: 'toProfile',
    value: function toProfile() {
      var history = this.props.history;

      this.props.setPathName('uu-dai/' + this.props.detail.handle);
      history.push('/chinh-sua-tai-khoan');
    }
  }, {
    key: 'closeModalInfo',
    value: function closeModalInfo() {
      this.setState({ showModalInfo: false });
    }
  }, {
    key: 'closeModalJoin',
    value: function closeModalJoin() {
      this.setState({ showModalJoin: false });
    }
  }, {
    key: 'openModalJoin',
    value: function openModalJoin() {
      this.setState({ showModalJoin: true });
    }
  }, {
    key: 'infoClass',
    value: function infoClass(code) {
      var styles = require('./Voucher.scss');
      switch (code) {
        case 'error':
          return styles.error;
        case 'warning':
          return styles.warning;
        case 'success':
          return styles.success;
        default:
          return '';
      }
    }
  }, {
    key: 'toBooking',
    value: function toBooking() {
      this.props.showDownloadAppPopup();
      // const {
      //   detail: { campaign, shop, service },
      //   setDefaultBooking,
      //   resetBooking,
      //   history,
      //   user,
      // } = this.props;
      // if (user) {
      //   resetBooking();
      //   const bookingServices = [
      //     { service: service._id, number: 1, name: service.name },
      //   ];
      //   const submit = { bookingServices, code: campaign.code, shop };
      //   setDefaultBooking(submit);
      //   history.push(`/dat-lich`);
      //   if (this.props.user) {
      //     ReactGA.event({
      //       category: 'Promotion',
      //       action: 'Clicked Booking button',
      //       label: `${campaign.code}`,
      //     });
      //     ReactGA.event({
      //       category: 'Booking',
      //       action: 'Clicked To Step 1 (General Voucher)',
      //       label: `${shop.name}`,
      //     });
      //   } else {
      //     ReactGA.event({
      //       category: 'Promotion',
      //       action: 'Clicked Booking button (not logged in)',
      //       label: `${campaign.code}`,
      //     });
      //   }
      // } else {
      //   this.handleLogin();
      // }
    }
  }, {
    key: 'onBookingCallButtonClick',
    value: function onBookingCallButtonClick() {
      var campaign = this.props.detail.campaign;

      _reactGa2.default.event({
        category: 'Promotion',
        action: 'Clicked Booking Call button',
        label: '' + campaign.code
      });
    }
  }, {
    key: 'allowRender',
    value: function allowRender() {
      // TODO: hàm này check điều kiện để render nội dung cho phù hợp
      // 1.1 package service trong couponcode phải là packageservice của packservice hiện hành.
      var detail = this.props.detail;

      var campaign = detail ? detail.campaign : {};
      if (!(0, _lodash.isEmpty)(campaign)) {
        return true;
      }
      return false;
    }
  }, {
    key: 'joined',
    value: function joined() {
      var _props2 = this.props,
          detail = _props2.detail,
          user = _props2.user;

      var campaign = detail ? detail.campaign : {};
      if (!(0, _lodash.isEmpty)(user) && !(0, _lodash.isEmpty)(campaign)) {
        return campaign && !campaign.isUsed && campaign.usersUsed && campaign.usersUsed.indexOf(this.props.user._id) !== -1;
      }
      return false;
    }
  }, {
    key: 'isGeneral',
    value: function isGeneral() {
      var campaign = this.props.detail.campaign;

      return campaign && !(0, _lodash.isEmpty)(campaign);
    }
  }, {
    key: 'renderButton',
    value: function renderButton() {
      var _props$detail = this.props.detail,
          campaign = _props$detail.campaign,
          shop = _props$detail.shop;

      var styles = require('./Voucher.scss');
      var expired = new Date() > (0, _moment2.default)(campaign.endDate);
      // return (
      //   <div className={`${styles.btn} ${styles.btnJoin} ${styles.exchangeBtn}`}>
      //     {`Đổi 600`}
      //     <img src={exuWhite}/>
      //   </div>
      // );
      if (campaign.isUsed) {
        return _react2.default.createElement(
          'div',
          {
            className: styles.btn + ' ' + styles.btnJoin + ' ' + styles.btnDisabled
          },
          _react2.default.createElement(
            'span',
            null,
            '\u0110\xE3 s\u1EED d\u1EE5ng'
          )
        );
      }
      if (expired) {
        return _react2.default.createElement(
          'a',
          {
            href: 'tel:' + (0, _lib.getPhone)(shop.phone),
            className: styles.btn + ' ' + styles.btnJoin + ' ' + styles.btnDisabled
          },
          _react2.default.createElement(
            'span',
            null,
            '\u0110\xE3 h\u1EBFt h\u1EA1n'
          )
        );
      }
      if (shop.isBooking) {
        return _react2.default.createElement(
          'div',
          {
            className: styles.btn + ' ' + styles.btnJoin + ' ' + styles.available,
            onClick: this.toBooking.bind(this)
          },
          '\u0110\u1EB7t L\u1ECBch'
        );
      }
      if (this.joined()) {
        return _react2.default.createElement(
          'a',
          {
            className: styles.btn + ' ' + styles.btnJoin,
            href: 'tel:' + (0, _lib.getPhone)(shop.phone),
            onClick: this.onBookingCallButtonClick.bind(this)
          },
          _react2.default.createElement(
            'span',
            null,
            'G\u1ECDi \u0110\u1EB7t L\u1ECBch'
          )
        );
      }
      return _react2.default.createElement(
        'div',
        {
          className: styles.btn + ' ' + styles.btnJoin + ' ' + styles.available,
          onClick: this.handleJoin.bind(this)
        },
        'Ch\u1ECDn \u01AFu \u0110\xE3i N\xE0y'
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./Voucher.scss');
      var detail = this.props.detail;
      var _state = this.state,
          infoMessage = _state.infoMessage,
          warningJoin = _state.warningJoin,
          showModalInfo = _state.showModalInfo,
          showModalJoin = _state.showModalJoin;

      var phone = null;
      if (this.props.user) {
        phone = this.props.user.phone;
      }
      var campaign = detail ? detail.campaign : {};
      var service = detail ? detail.service : {};
      var shop = detail ? detail.shop : {};
      return _react2.default.createElement(
        'div',
        { style: { display: 'block', width: '100%', height: '100%' } },
        !(0, _lodash.isEmpty)(detail) && this.allowRender() ? _react2.default.createElement(
          'div',
          {
            id: 'voucherDetail',
            className: styles.voucherDetail,
            ref: 'voucherDetail'
          },
          _react2.default.createElement(
            'div',
            { className: styles.modalBody },
            _react2.default.createElement(
              'div',
              { className: styles.image },
              _react2.default.createElement('i', {
                className: 'fa fa-angle-left',
                onClick: this.props.history.goBack
              }),
              _react2.default.createElement('img', { src: detail.image || _image_voucher2.default, alt: 'H\xECnh avatar' })
            ),
            _react2.default.createElement(
              'div',
              { className: styles.primaryInfo },
              _react2.default.createElement(
                'div',
                { className: styles.info },
                _react2.default.createElement(
                  'div',
                  { className: styles.title },
                  campaign.name
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.shop },
                  _react2.default.createElement('img', { src: _store2.default, alt: '' }),
                  shop.name,
                  ' -',
                  ' ',
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { to: '/' + shop.handle },
                    'Th\xF4ng tin shop'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.address },
                  _react2.default.createElement('img', {
                    className: styles.locationIcon,
                    src: _mapMarker2.default,
                    alt: ''
                  }),
                  shop.address
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.service },
                  _react2.default.createElement('img', { src: _saleBadge2.default, alt: '' }),
                  service.name
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.times },
                  _react2.default.createElement('img', { src: _calendar2.default, alt: '' }),
                  'T\u1EEB ' + (0, _moment2.default)(new Date(campaign.startDate)).format('DD/MM/YYYY') + ' \u0111\u1EBFn ' + (0, _moment2.default)(new Date(campaign.endDate)).format('DD/MM/YYYY')
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.price },
                  _react2.default.createElement('img', { src: _gift2.default, alt: '' }),
                  _react2.default.createElement(
                    'span',
                    { className: styles.newPrice },
                    (0, _numeral2.default)(detail.displayValue).format('0,0') + ' đ'
                  ),
                  _react2.default.createElement(
                    'span',
                    { className: styles.oldPrice },
                    (0, _numeral2.default)(service.price).format('0,0') + ' đ'
                  )
                )
              ),
              campaign && !(0, _lodash.isEmpty)(campaign) && this.joined() && _react2.default.createElement(
                'div',
                { className: styles.serviceCode },
                _react2.default.createElement(
                  'h2',
                  { className: styles.lmTitle, style: { marginBottom: 0 } },
                  'M\xE3 s\u1EED d\u1EE5ng d\u1ECBch v\u1EE5'
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.code },
                  '' + campaign.code + (phone && phone.length >= 4 ? phone.substring(phone.length - 4, phone.length) : '')
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.qrCodeContainer },
                  _react2.default.createElement(_reactQrSvg.QRCode, {
                    value: '' + campaign.code + (phone && phone.length >= 4 ? phone.substring(phone.length - 4, phone.length) : ''),
                    style: { width: 128 }
                  })
                ),
                _react2.default.createElement(
                  'span',
                  { className: styles.serviceCodeHint },
                  '* Vui l\xF2ng \u0111\u01B0a m\xE3 QR ho\u1EB7c copy m\xE3 ph\xEDa tr\xEAn cho nh\xE2n vi\xEAn \u0111\u1EC3 s\u1EED d\u1EE5ng d\u1ECBch v\u1EE5, ho\u1EB7c g\u1ECDi \u0111\u1EB7t l\u1ECBch b\xEAn d\u01B0\u1EDBi \u0111\xE2y.'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: styles.description },
                _react2.default.createElement(
                  'h2',
                  { className: styles.lmTitle },
                  'M\xF4 t\u1EA3 d\u1ECBch v\u1EE5'
                ),
                _react2.default.createElement('div', {
                  className: styles.content,
                  dangerouslySetInnerHTML: { __html: service.description }
                })
              ),
              _react2.default.createElement(
                'div',
                { className: styles.condition },
                _react2.default.createElement(
                  'h2',
                  { className: styles.lmTitle },
                  '\u0110i\u1EC1u ki\u1EC7n s\u1EED d\u1EE5ng'
                ),
                _react2.default.createElement('div', {
                  className: styles.content,
                  dangerouslySetInnerHTML: { __html: campaign.condition }
                })
              ),
              _react2.default.createElement(
                'div',
                { className: styles.btnGroup },
                this.renderButton()
              )
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal,
            {
              onHide: this.closeModalJoin.bind(this),
              show: showModalJoin,
              className: 'joinModal ' + styles.modal
            },
            _react2.default.createElement(
              _reactBootstrap.Modal.Header,
              {
                closeButton: true,
                className: this.infoClass.call(this, warningJoin.code)
              },
              _react2.default.createElement(
                'div',
                { className: styles.modalHeader },
                _react2.default.createElement(
                  'span',
                  { className: styles.tilte },
                  warningJoin.title
                )
              )
            ),
            _react2.default.createElement(
              _reactBootstrap.Modal.Body,
              null,
              _react2.default.createElement(
                'div',
                { className: styles.modalBody },
                warningJoin.content
              )
            ),
            _react2.default.createElement(
              _reactBootstrap.Modal.Footer,
              null,
              _react2.default.createElement(
                'div',
                { className: styles.modalFooter },
                _react2.default.createElement(
                  'div',
                  {
                    className: styles.btn + ' ' + styles.btnClose,
                    onClick: this.closeModalJoin.bind(this)
                  },
                  'Tho\xE1t'
                ),
                _react2.default.createElement(
                  'div',
                  {
                    className: styles.btn + ' ' + styles.btnJoin + ' ',
                    onClick: this.joinCampaign.bind(this)
                  },
                  'Ch\u1EAFc Ch\u1EAFn'
                )
              )
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal,
            {
              onHide: this.closeModalInfo.bind(this),
              show: showModalInfo,
              className: 'voucherModal ' + styles.modal
            },
            _react2.default.createElement(
              _reactBootstrap.Modal.Header,
              {
                closeButton: true,
                className: this.infoClass.call(this, infoMessage.status)
              },
              _react2.default.createElement(
                'div',
                { className: styles.modalHeader },
                _react2.default.createElement(
                  'span',
                  { className: styles.tilte },
                  infoMessage.title
                )
              )
            ),
            _react2.default.createElement(
              _reactBootstrap.Modal.Body,
              null,
              _react2.default.createElement(
                'div',
                { className: styles.modalBody },
                infoMessage.content
              )
            ),
            infoMessage.call && _react2.default.createElement(
              _reactBootstrap.Modal.Footer,
              null,
              _react2.default.createElement(
                'div',
                { className: styles.modalFooter },
                _react2.default.createElement(
                  'a',
                  {
                    className: styles.btn + ' ' + styles.btnJoin,
                    onClick: this.closeModalInfo.bind(this)
                  },
                  'Xong'
                )
              )
            ),
            infoMessage.require === 'login' && _react2.default.createElement(
              _reactBootstrap.Modal.Footer,
              null,
              _react2.default.createElement(
                'div',
                { className: styles.modalFooter },
                _react2.default.createElement(
                  'div',
                  {
                    className: styles.btn + ' ' + styles.btnClose,
                    onClick: this.closeModalInfo.bind(this)
                  },
                  'Tho\xE1t'
                ),
                _react2.default.createElement(
                  'div',
                  {
                    className: styles.btn + ' ' + styles.btnJoin,
                    onClick: this.handleLogin.bind(this)
                  },
                  '\u0110\u0103ng Nh\u1EADp'
                )
              )
            ),
            infoMessage.require === 'update_phone' && _react2.default.createElement(
              _reactBootstrap.Modal.Footer,
              null,
              _react2.default.createElement(
                'div',
                { className: styles.modalFooter },
                _react2.default.createElement(
                  'div',
                  {
                    className: styles.btn + ' ' + styles.btnClose,
                    onClick: this.closeModalInfo.bind(this)
                  },
                  'Tho\xE1t'
                ),
                _react2.default.createElement(
                  'div',
                  {
                    className: styles.btn + ' ' + styles.btnJoin,
                    onClick: this.toProfile.bind(this)
                  },
                  'Th\xF4ng Tin T\xE0i Kho\u1EA3n'
                )
              )
            )
          )
        ) : _react2.default.createElement(
          'div',
          { className: styles.notfound },
          'Trang kh\xF4ng t\xECm th\u1EA5y'
        )
      );
    }
  }]);
  return VoucherDetail;
}(_react.Component), _class2.propTypes = {
  // @data
  params: _react.PropTypes.object,
  route: _react.PropTypes.object,
  reward_detail: _react.PropTypes.object,
  detail: _react.PropTypes.object,
  toggleJoin: _react.PropTypes.bool,
  joinCampaignData: _react.PropTypes.object,
  joinCampaignError: _react.PropTypes.object,
  user: _react.PropTypes.object,
  // code: PropTypes.object,
  // promotionsEnterprise: PropTypes.object,
  history: _react.PropTypes.object,
  // @action
  getVoucherById: _react.PropTypes.func,
  setCouponCode: _react.PropTypes.func,
  joinCampaign: _react.PropTypes.func,
  getRewardDetails: _react.PropTypes.func,
  setDefaultBooking: _react.PropTypes.func,
  setPathName: _react.PropTypes.func.isRequired,
  resetBooking: _react.PropTypes.func,
  showDownloadAppPopup: _react.PropTypes.func
}, _temp2)) || _class);
exports.default = VoucherDetail;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Voucher/CampaignGeneralDetail.js
// module id = 1637
// module chunks = 0